
import { baseApi } from "../baseApi";

export const SettingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCompanyDetail: builder.query({
       query: ({company }) => ({
    url: `/api/method/frappe.desk.form.load.getdoc?doctype=WMS Settings&name=${company}`,
  }),
     
    }),
    getListWms:builder.mutation({
      query: (data) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_wms_settings_list`,
        method:'POST',
        body:data
      }),
    }),
    postWmsSettingDetail: builder.mutation({
      query: () => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.get_wms_settings`,
        method: 'POST'
      }),
    }),
    postWmsSettingCreation: builder.mutation({
      query: (body) => ({
        url: `/api/resource/WMS Settings`,
        method: 'POST',
        body
      }),
    }),
    postWmsSettingUpdate: builder.mutation({
      query: (body) => ({
        url: `/api/method/stackerbee_mobile_wms.wms.api.update_wms_settings`,
        method: 'POST',
        body
      }),
    }),
  }),
});

export const { useGetCompanyDetailQuery,useGetListWmsMutation,usePostWmsSettingDetailMutation,usePostWmsSettingUpdateMutation,usePostWmsSettingCreationMutation } = SettingApi;
